<template>
  <div class="offers-list">
    <div v-if="offers.length" class="offers-list-page__listing">
      <OfferCard
        v-for="offer in offers"
        :key="offer.id"
        :first-offer="offer"
        :url="getSellerOfferUrl(offer)"
        is-owner-view
        :carousel-height="220"
      >
        <template #footer>
          <OfferActions :offer="offer" class="offer__actions" />
        </template>
      </OfferCard>
      <div v-if="!hasNextPage" class="offer offer-admin gr-12@mobile gr-6@tablet gr-4 gr-3@desktop">
        <div class="offers-list-page__add-offer">
          <a class="btn btn--primary" :href="urlAddOffer">
            {{ trans('office_offer.create') }}
          </a>
        </div>
      </div>
    </div>
    <OfferCardEmpty v-else />
  </div>
</template>
<script>
import OfferCard from '@components/offer-card/OfferCard.vue';
import { getSellerOfferUrl } from '@organisms/offer/offer-utils';
import { useOfferListStore } from '@stores/useOfferListStore';
import { URL_OFFER_CREATE } from '@tools/routes/routes';
import { trans } from '@elements/translation';
import { storeToRefs } from 'pinia';
import OfferCardEmpty from './OfferCardEmpty.vue';
import OfferActions from './OfferActions.vue';

export default {
  components: { OfferActions, OfferCardEmpty, OfferCard },
  setup() {
    const store = useOfferListStore();
    const { isLoading, offers, hasNextPage } = storeToRefs(store);
    return {
      isLoading,
      offers,
      hasNextPage,
    };
  },
  data() {
    return {
      urlAddOffer: URL_OFFER_CREATE,
    };
  },
  methods: { trans, getSellerOfferUrl },
};
</script>
